import React, { useMemo } from 'react'
import { useAppSelector } from 'app/store'
import withProgress from 'core/components/progress/withProgress'
import Dropdown from 'core/elements/dropdown'
import useListAction from 'core/hooks/useListAction'
import { listImages } from '../images/actions'
import { imagesSelector } from '../images/selectors'

const AsyncDropdown = withProgress(Dropdown, { inline: true })

const ImagePicklist = ({
  disabled = false,
  name = 'images',
  label = 'Image Name',
  includeNoneOption = false,
  filterFn = null,
  ...rest
}) => {
  const { loading } = useListAction(listImages, { params: {} })
  const images = useAppSelector(imagesSelector)

  const options = useMemo(() => {
    const filteredOptions = filterFn ? filterFn(images) : images
    const imageOptions = filteredOptions.map((image) => ({
      label: image?.name || image?.id,
      value: image?.id,
    }))
    return includeNoneOption ? [{ label: 'None', value: '' }, ...imageOptions] : imageOptions
  }, [images])

  return (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      loading={loading}
      items={options}
    />
  )
}

export default ImagePicklist
